<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Create Jobboard Spec</h4>
        </div>
        <div class="card-body">
          <BForm @submit="handleSubmit">
            <BFormGroup label="Name">
              <BFormInput v-model="payload.name" required />
            </BFormGroup>
            <BButton type="submit" variant="primary">Save</BButton>
          </BForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
export default {
  components: { BForm, BFormGroup, BFormInput, BButton },
  data() {
    return {
      payload: {
        name: ""
      }
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      this.$http
        .post("/enroll_admin/jobboard-spec", this.payload)
        .then(() => this.$router.push({ name: "jobboard-spec" }));
    }
  }
};
</script>
